import { useRef } from 'react';

import { IconX } from '@tabler/icons-react';

import { List, ListItem, Surface } from '@cfa/react-components';

interface SearchBarSuggestionsProps {
  suggestions: string[];
  onSetSuggestion: (suggestion: string) => void;
  onRemoveSuggestion: (suggestion: string) => void;
}

const SearchbarSuggestionsDropdown: React.FC<SearchBarSuggestionsProps> = ({
  suggestions,
  onSetSuggestion,
  onRemoveSuggestion,
}) => {
  const mouseDownSuggestionRef = useRef<string | null>(null);

  return (
    <Surface
      className="absolute inset-x-0 top-full z-5000"
      data-testid="DesktopSearchHistory"
      elevation={1}
    >
      <List className="p-0!" divider="inset" variant="default">
        {suggestions.map((suggestion, index) => (
          <ListItem
            className="cursor-pointer"
            data-testid={`SearchTermHistory${index}`}
            endItem={
              <IconX
                onMouseDown={e => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onClick={e => {
                  e.stopPropagation();
                  onRemoveSuggestion(suggestion);
                }}
              />
            }
            key={suggestion}
            onMouseDown={e => {
              // Submit on mousedown so blur does not unmount the row before click.
              e.preventDefault();
              e.stopPropagation();
              mouseDownSuggestionRef.current = suggestion;
              onSetSuggestion(suggestion);
            }}
            onClick={e => {
              // Keyboard activation synthesizes click without mousedown.
              e.preventDefault();
              e.stopPropagation();
              if (mouseDownSuggestionRef.current === suggestion) {
                mouseDownSuggestionRef.current = null;
                return;
              }
              onSetSuggestion(suggestion);
            }}
          >
            {suggestion}
          </ListItem>
        ))}
      </List>
    </Surface>
  );
};

export default SearchbarSuggestionsDropdown;
